import styled from "styled-components"

import StatefulInputWithLinethrough from "Catalog/Edit/shared/components/StatefulInputWithLinethrough"
import StatefulField from "shared/components/StatefulField"

export const FieldName = styled(StatefulInputWithLinethrough)`
  input {
    width: 7rem;
    text-overflow: ellipsis;
  }
`

export const FieldPrice = styled(StatefulField.MoneyInput)`
  input {
    width: 4rem;
  }
`

export const FieldRef = styled(StatefulField.Input)`
  input {
    width: 7rem;
    text-overflow: ellipsis;
  }
`

export const FieldCheckbox = styled(StatefulField.Checkbox)`
  input {
    width: 2rem;
  }
`
